<template>
    <Layout is-crm class="transitions" :content-class="'content--narrow'">
        <h1 v-t="'crm.transitions.title'" />
        <PaginatedResource
            :fetch-method="options.fetch"
            :filter-fields="options.filter"
            filter-key="transitions"
        >
            <template
                #default="{ loading, resource, isEmpty, canLoadMore, loadMore, filter, filters }"
            >
                <div class="transitions__paginated">
                    <Spinner v-if="loading" />
                    <TransitionsFilters :filters="filters" @filter="filter" />
                    <TransitionsResults :items="resource" :loading="loading" :is-empty="isEmpty" />

                    <div v-if="canLoadMore" class="transitions__loadmore">
                        <button
                            v-t="'misc.loadmore'"
                            class="button button--big button--blank"
                            type="button"
                            @click="loadMore"
                        />
                    </div>
                </div>
            </template>
        </PaginatedResource>
    </Layout>
</template>

<script>
import { fetchResults } from '../../api/metas';
import { TransitionsFilters, TransitionsResults } from '../../components';
import Spinner from '@speechki-frontend/shared/ui/Spinner';
import PaginatedResource from '@speechki-frontend/shared/PaginatedResource';
import Layout from '@speechki-frontend/shared/ui/layout/Layout';

export default {
    name: 'TransitionMetasPage',
    components: {
        Spinner,
        Layout,
        PaginatedResource,
        TransitionsFilters,
        TransitionsResults,
    },
    data() {
        return {
            options: {
                fetch: fetchResults,
                filter: ['flow', 'source_state', 'destination_state'],
            },
        };
    },
};
</script>
